import React, { Component } from 'react';
import UserHelper from '../../../../helper/user.js'
import PermissionProperties from '../../../../config/permission.js'
// import moment from 'moment';
export default class Row extends Component{
  __RenderActionButton__(){
    var jsx = []
    let i=1;
    if(UserHelper.HasPermission(PermissionProperties.ASSET.TRACKING.UPDATE,this.props.UserReducer)){
      jsx.push(
          <td key={i++}><button type="button" onClick={()=> this.props.self.__OnUpdateCLicked__(this.props.data)} className="btn btn-primary"><i className="icon-pencil"></i>&nbsp; Edit</button></td>
      )
    }
    if(UserHelper.HasPermission(PermissionProperties.ASSET.TRACKING.DELETE,this.props.UserReducer)){
      jsx.push(
          <td key={i++}><button type="button" onClick={()=> this.props.self.__OnDeleteCLicked__(this.props.data)} className="btn btn-danger"><i className="icon-trash"></i>&nbsp; Delete</button></td>
      )
    }
    return jsx
  }
  render(){
    return(
      <tr key={this.props.data.Alias} role = 'button' onClick={()=>this.props.history.push("/admin/master-asset-details-"+this.props.data.Alias+"/")}>
        <td>{this.props.data.Alias}</td>
        <td>{this.props.data.Tag ? this.props.data.Tag : '-'}</td>
        <td>{this.props.data.Name}</td>
        {/*<td>{this.props.data.Description}</td>*/}
        <td>{this.props.data.Type}</td>
        <td>{this.props.data.SerialNumber}</td>
        <td>{this.props.data.PurchasedDate}</td>
        {/*<td>{this.props.data.PurchaseCurrency}</td>
        <td>{this.props.data.PurchasePrice}</td>
        <td>{this.props.data.PurchaseOrder}</td>
        <td>{this.props.data.PurchaseVendor}</td>*/}
        <td>{this.props.data.Status}</td>
        {/*<td>{this.props.data.CreatedBy}</td>
        <td>{moment(this.props.data.CreatedTime,"YYYY-MM-DD").format('YYYY-MM-DD')}</td>
        <td>{this.props.data.ModifiedBy}</td>
        <td>{this.props.data.ModifiedTime !== null?moment(this.props.data.ModifiedTime,"YYYY-MM-DD").format('YYYY-MM-DD'):''}</td>*/}
        {/*<td><a href={"/admin/master-asset-details-"+this.props.data.Alias+"/"}>{this.props.data.Name+" Details"}</a></td>*/}
        {/*<td><button type="button" onClick={()=> this.props.self.__OnUpdateCLicked__(this.props.data)} className="btn btn-primary"><i className="icon-pencil"></i>&nbsp; Edit</button></td>
        <td><button type="button" onClick={()=> this.props.self.__OnDeleteCLicked__(this.props.data)} className="btn btn-danger"><i className="icon-trash"></i>&nbsp; Delete</button></td>
        {this.__RenderActionButton__()}*/}
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/asset/helper/children/row.js